/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPhysicianPage } from './HchbPhysicianPage';
import {
    HchbPhysicianPageFromJSON,
    HchbPhysicianPageFromJSONTyped,
    HchbPhysicianPageToJSON,
} from './HchbPhysicianPage';

/**
 * 
 * @export
 * @interface FindAllHchbPhysicians200Response
 */
export interface FindAllHchbPhysicians200Response {
    /**
     * 
     * @type {HchbPhysicianPage}
     * @memberof FindAllHchbPhysicians200Response
     */
    data?: HchbPhysicianPage;
}

/**
 * Check if a given object implements the FindAllHchbPhysicians200Response interface.
 */
export function instanceOfFindAllHchbPhysicians200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbPhysicians200ResponseFromJSON(json: any): FindAllHchbPhysicians200Response {
    return FindAllHchbPhysicians200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPhysicians200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPhysicians200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbPhysicianPageFromJSON(json['data']),
    };
}

export function FindAllHchbPhysicians200ResponseToJSON(value?: FindAllHchbPhysicians200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbPhysicianPageToJSON(value.data),
    };
}

